<div class="d-flex flex-column min-vh-100">
  <app-header-buscador *ngIf="onlyDetails"></app-header-buscador>
  <div *ngIf="loading; else propertyBlock">
    <div class="d-flex justify-content-center align-items-center" style="height: 50vh">
      <div
        class="spinner-border"
        [style]="'color:' + config?.primaryColor + ' !important;'"
        role="status"
        style="width: 4rem; height: 4rem"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <ng-template #propertyBlock>
    <ng-container *ngIf="property.status == 2 || property.status == 0; else propView">
      <div class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 offset-md-4 offset-lg-4 offset-xl-4 my-2">
        <div class="card text-center">
          <div class="card-body">
            <h4 class="card-title">Esta propiedad no esta disponible</h4>
            <p class="card-text">Esta propiedad fue eliminada o deshabilitada</p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #propView>
      <ng-container *ngIf="config?.theme === 1">
        <div class="container-lg container-md container-xl">
          <div class="row mt-1">
            <div class="col">
              <div class="d-flex justify-content-between p-1">
                <div>
                  <h1
                    class="titulo"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                    style="font-weight: 500"
                  >
                    {{ property.title }}
                  </h1>
                  <h6 class="estado">
                    {{ cpName == 0 ? "" : cpName + ", " }}{{ suburbName == "" ? "" : suburbName + ", "
                    }}{{ stateName }},
                    {{ provinceName }}
                  </h6>
                  <ng-container *ngIf="property.real_estate.id == config.real_estate_id">
                    <h6 class="estado">Código: {{ property.code }}</h6>
                  </ng-container>
                  <h3 class="operation">{{ property.operationType }}</h3>
                </div>
                <div></div>
              </div>
              <div class="row justify-content-center oculto">
                <ngb-carousel>
                  <ng-template ngbSlide *ngFor="let imgs of carrusel; let indexOfelement = index">
                    <div class="carousel-img-wrapper" (click)="showGallery(indexOfelement)">
                      <img [src]="imgs" class="imagenCarrusel img-fluid rounded" alt="Random first slide" />
                    </div>
                    <div class="carousel-caption"></div>
                  </ng-template>
                </ngb-carousel>
                <br />
              </div>
              <div style="display: flex; justify-content: center">
                <div class="row justify-content-center principal dimensionBloImgs" [ngSwitch]="true">
                  <div class="col-6 p-0 h-100" (click)="showGallery(0)">
                    <img
                      [src]="firstImage"
                      class="img-fluid firstImage"
                      style="border-radius: 20px 0 0 20px"
                      (error)="handleMissingImage($event)"
                    />
                  </div>
                  <div class="col-6 p-0 h-100">
                    <div class="row h-50 ml-0">
                      <div class="col-6 h-100" style="padding-left: 7px; padding-right: 2px" (click)="showGallery(1)">
                        <img [src]="secondImage" class="img-fluid firstImage" (error)="handleMissingImage($event)" />
                      </div>
                      <div class="col-6 h-100" style="padding-left: 5px" (click)="showGallery(2)">
                        <img
                          [src]="thirdImage"
                          class="img-fluid firstImage"
                          style="border-radius: 0 20px 0 0"
                          (error)="handleMissingImage($event)"
                        />
                      </div>
                    </div>
                    <div class="row h-50 ml-0">
                      <div
                        class="col-6 h-100"
                        style="padding-left: 7px; padding-right: 2px; padding-top: 7px"
                        (click)="showGallery(3)"
                      >
                        <img [src]="fourthImage" class="img-fluid firstImage" (error)="handleMissingImage($event)" />
                      </div>

                      <div class="col-6 h-100" style="padding-left: 5px; padding-top: 7px" (click)="showGallery(4)">
                        <img
                          [src]="fifthImage"
                          class="img-fluid firstImage"
                          (error)="handleMissingImage($event)"
                          style="border-radius: 0 0 20px 0"
                        />
                      </div>
                    </div>

                    <div class="btn-flotante" *ngIf="property.propertyImages.length > 5">
                      <button type="button" class="btn rounded btn-secondary" rippleEffect (click)="showGallery(5)">
                        <i data-feather="eye" class="mr-0 mr-sm-1"></i>
                        Ver más fotos
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="property.videoUrl && property.videoUrl != 0 && property.videoUrl != null">
                <div class="col-12">
                  <div class="text-center">
                    <h3 class="mt-1">Video</h3>
                    <iframe
                      width="100%"
                      style="max-width: 560px"
                      height="315"
                      [src]="videoUrlSafe"
                      [title]="property.title"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <h3>Descripción</h3>
                  <div style="white-space: pre-line">
                    {{ property.description }}
                  </div>
                  <br />
                  <div>
                    <div *ngFor="let pb of property.property_buttons">
                      <button
                        type="button"
                        class="btn btn-relief-primary round mb-1"
                        style="width: 300px"
                        (click)="linkTo(pb.url)"
                      >
                        {{ pb.description }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <h3>Lo que ofrece este lugar</h3>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.front != 0">
                        <img src="assets/icon/IconBlue/area.png" height="18" width="18" />
                        &nbsp;
                        <span>{{ property.front | number : "1.0-0" }} m </span>
                        <div class="amenity">Frente</div>
                      </div>
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.depth != 0">
                        <img src="assets/icon/IconBlue/area.png" height="18" width="18" />
                        &nbsp;
                        <span>{{ property.depth | number : "1.0-0" }} m </span>
                        <div class="amenity">Fondo</div>
                      </div>
                      <div *ngFor="let amenityB of amenities_base" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityB.icon" height="18" width="18" />
                        &nbsp;
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') == 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') != 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-1" }}
                        </span>
                        <span *ngIf="amenityB.id == 2 && amenityB.cantidad >= 4"> Más de 3 </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad != '4.00'
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span *ngIf="amenityB.id == 3 && amenityB.cantidad == 0"> Sin </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad == '4.00'
                          "
                        >
                          Más de 3
                        </span>
                        <span *ngIf="amenityB.id == 4 || amenityB.id == 5">
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span *ngIf="amenityB.id == 7 && amenityB.cantidad > 0">SI </span>
                        <span *ngIf="amenityB.id == 8 && amenityB.cantidad > 0">SI </span>
                        <span *ngIf="amenityB.id == 9 && amenityB.cantidad > 0">SI </span>
                        <span *ngIf="amenityB.cantidad == 0">NO </span>
                        <div [innerHTML]="amenityB.name" class="amenity"></div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <div *ngFor="let amenityOp of amenities_ops" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityOp.icon" height="18" width="18" />
                        &nbsp;
                        <div [innerHTML]="amenityOp.name" class="amenity"></div>
                      </div>
                    </div>
                  </div>
                  <div class="contactBtn p-1" *ngIf="onlyDetails" style="z-index: 10">
                    <div class="d-flex justify-content-center">
                      <div class="container-whats mt-1" (click)="sendWhatsApp()">
                        <div class="contour">
                          <img
                            *ngIf="config?.logo"
                            [src]="config?.logo"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            style="border-radius: 100%"
                          />
                          <img
                            *ngIf="!config?.logo"
                            src="r../../../../../assets/images/phone2.png"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            class="fas"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row" *ngIf="property?.url_soc">
                  <div class="col-12 col-md-8 mb-1">
                    <a target="_blank" href="{{ property?.url_soc }}" class="soc-button">
                      <img
                        src="https://socasesores.com/simulador-credito-hipotecario/img/icono_blanco.png"
                        width="20%"
                        height="auto"
                      />
                      &nbsp;Simula tu hipoteca
                    </a>
                  </div>
                </div>
                <div class="row" *ngIf="property?.real_estate.url_soc">
                  <div class="col-12 col-md-8 mb-1">
                    <a target="_blank" href="{{ property?.real_estate.url_soc }}" class="soc-button">
                      <img
                        src="https://socasesores.com/simulador-credito-hipotecario/img/icono_blanco.png"
                        width="20%"
                        height="auto"
                      />
                      &nbsp;Simula tu hipoteca
                    </a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-8 mb-1">
                    <h1
                      class="price"
                      [style]="'color:' + config?.primaryColor + ' !important;'"
                      style="font-size: 3.5rem"
                    >
                      {{ property.price | customCurrency }} {{ getCoinTypeName(property.coin_type) }}
                      <a (click)="redirect(modalBasic)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          height="40"
                          fill="currentColor"
                          class="calculator"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                          />
                          <path
                            d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"
                          />
                        </svg>
                      </a>
                    </h1>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="config?.theme === 2">
        <div class="container-lg container-md container-xl">
          <div class="row mt-1">
            <div class="col">
              <div class="d-flex justify-content-between p-1">
                <div>
                  <h1
                    class="titulo"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                    style="font-weight: 500"
                  >
                    {{ property.title }}
                  </h1>
                  <h6 class="estado">
                    {{ cpName == 0 ? "" : cpName + ", " }}{{ suburbName == "" ? "" : suburbName + ", "
                    }}{{ stateName }},
                    {{ provinceName }}
                  </h6>
                  <ng-container *ngIf="property.real_estate.id == config.real_estate_id">
                    <h6 class="estado">Código: {{ property.code }}</h6>
                  </ng-container>
                  <h3 class="operation">{{ property.operationType }}</h3>
                </div>
              </div>
              <div class="row justify-content-center oculto">
                <ngb-carousel>
                  <ng-template ngbSlide *ngFor="let imgs of carrusel; let indexOfelement = index">
                    <div class="carousel-img-wrapper" (click)="showGallery(indexOfelement)">
                      <img [src]="imgs" class="imagenCarrusel img-fluid rounded" alt="Random first slide" />
                    </div>
                    <div class="carousel-caption"></div>
                  </ng-template>
                </ngb-carousel>
              </div>
              <div style="display: flex; justify-content: center" class="px-1">
                <div class="row justify-content-center principal dimensionBloImgs" [ngSwitch]="true">
                  <div class="col-6 p-0 h-100" (click)="showGallery(0)">
                    <img
                      [src]="firstImage"
                      class="img-fluid firstImage"
                      style="border-radius: 20px 0 0 20px"
                      (error)="handleMissingImage($event)"
                    />
                  </div>
                  <div class="col-6 p-0 h-100">
                    <div class="row h-50 ml-0">
                      <div class="col-6 h-100" style="padding-left: 7px; padding-right: 2px" (click)="showGallery(1)">
                        <img [src]="secondImage" class="img-fluid firstImage" (error)="handleMissingImage($event)" />
                      </div>

                      <div class="col-6 h-100" style="padding-left: 5px" (click)="showGallery(2)">
                        <img
                          [src]="thirdImage"
                          class="img-fluid firstImage"
                          style="border-radius: 0 20px 0 0"
                          (error)="handleMissingImage($event)"
                        />
                      </div>
                    </div>
                    <div class="row h-50 ml-0">
                      <div
                        class="col-6 h-100"
                        style="padding-left: 7px; padding-right: 2px; padding-top: 7px"
                        (click)="showGallery(3)"
                      >
                        <img [src]="fourthImage" class="img-fluid firstImage" (error)="handleMissingImage($event)" />
                      </div>

                      <div class="col-6 h-100" style="padding-left: 5px; padding-top: 7px" (click)="showGallery(4)">
                        <img
                          [src]="fifthImage"
                          class="img-fluid firstImage"
                          (error)="handleMissingImage($event)"
                          style="border-radius: 0 0 20px 0"
                        />
                      </div>
                    </div>

                    <div class="btn-flotante" *ngIf="property.propertyImages.length > 5">
                      <button
                        type="button"
                        class="btn rounded btn-secondary"
                        rippleEffect
                        (click)="showGallery(5)"
                        *ngIf="!property?.videoUrl || !property?.videoUrl == 0"
                      >
                        <i data-feather="eye" class="mr-0 mr-sm-1"></i>
                        Ver más fotos
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="property.videoUrl && property.videoUrl != 0 && property.videoUrl != null">
                <div class="col-12">
                  <div class="text-center">
                    <h3 class="mt-1">Video</h3>
                    <iframe
                      width="100%"
                      style="max-width: 560px"
                      height="315"
                      [src]="videoUrlSafe"
                      [title]="property.title"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
              <br />
              <div class="row px-1">
                <div class="col-xs-12 col-md-6">
                  <h3>Descripción</h3>
                  <div style="white-space: pre-line">
                    {{ property.description }}
                  </div>
                  <br />
                  <div>
                    <div *ngFor="let pb of property.property_buttons">
                      <button
                        type="button"
                        class="btn btn-relief-primary round mb-1"
                        style="width: 300px"
                        (click)="linkTo(pb.url)"
                      >
                        {{ pb.description }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <h3>Lo que ofrece este lugar</h3>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.front != 0">
                        <img src="assets/icon/IconBlue/area.png" height="18" width="18" />
                        &nbsp;
                        <span>{{ property.front | number : "1.0-0" }} m </span>
                        <div class="amenity">Frente</div>
                      </div>
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.depth != 0">
                        <img src="assets/icon/IconBlue/area.png" height="18" width="18" />
                        &nbsp;
                        <span>{{ property.depth | number : "1.0-0" }} m </span>
                        <div class="amenity">Fondo</div>
                      </div>
                      <div *ngFor="let amenityB of amenities_base" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityB.icon" height="18" width="18" />
                        &nbsp;
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') == 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') != 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-1" }}
                        </span>
                        <span *ngIf="amenityB.id == 2 && amenityB.cantidad >= 4"> Más de 3 </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad != '4.00'
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span *ngIf="amenityB.id == 3 && amenityB.cantidad == 0"> Sin </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad == '4.00'
                          "
                        >
                          Más de 3
                        </span>
                        <span *ngIf="amenityB.id == 4 || amenityB.id == 5">
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <div [innerHTML]="amenityB.name" class="amenity"></div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <div *ngFor="let amenityOp of amenities_ops" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityOp.icon" height="18" width="18" />
                        &nbsp;
                        <div [innerHTML]="amenityOp.name" class="amenity"></div>
                      </div>
                    </div>
                  </div>
                  <div class="contactBtn p-1" *ngIf="onlyDetails" style="z-index: 10">
                    <div class="d-flex justify-content-center">
                      <div class="container-whats mt-1" (click)="sendWhatsApp()">
                        <div class="contour">
                          <img
                            *ngIf="config?.logo"
                            [src]="config?.logo"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            style="border-radius: 100%"
                          />
                          <img
                            *ngIf="!config?.logo"
                            src="r../../../../../assets/images/phone2.png"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            class="fas"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="property?.real_estate.url_soc">
                <div class="col-12 mb-1 justify-content-center d-flex">
                  <a target="_blank" href="{{ property?.real_estate.url_soc }}" class="soc-button">
                    <img
                      src="https://socasesores.com/simulador-credito-hipotecario/img/icono_blanco.png"
                      width="20%"
                      height="auto"
                    />
                    &nbsp;Simula tu hipoteca
                  </a>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-1">
                  <h1
                    class="price"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                    style="font-size: 3.5rem; text-align: center"
                  >
                    {{ property.price | customCurrency }} {{ getCoinTypeName(property.coin_type) }}
                    <a (click)="redirect(modalBasic)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        fill="currentColor"
                        class="calculator"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                        />
                        <path
                          d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"
                        />
                      </svg>
                    </a>
                  </h1>
                </div>
              </div>

              <br />
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="config?.theme === 3">
        <div class="container-lg container-md container-xl">
          <div class="row mt-1">
            <div class="col">
              <div class="cardBloque p-2 mb-1">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <h1 class="titulo" style="color: #125eac; font-weight: 500">{{ property.title }}</h1>
                    <h6 class="estado">
                      {{ cpName == 0 ? "" : cpName + ", " }}{{ suburbName == "" ? "" : suburbName + ", "
                      }}{{ stateName }},
                      {{ provinceName }}
                    </h6>
                    <ng-container *ngIf="property.real_estate.id == config.real_estate_id">
                      <h6 class="estado">Código: {{ property.code }}</h6>
                    </ng-container>
                    <h3 class="operation" style="color: #125eac">{{ property.operationType }}</h3>
                  </div>

                  <div class="col-12 col-sm-6 d-flex flex-column justify-content-center align-items-end">
                    <h1>{{ property.price | customCurrency }} {{ getCoinTypeName(property.coin_type) }}</h1>
                    <div *ngIf="property?.real_estate.url_soc" class="mt-1">
                      <a target="_blank" href="{{ property?.real_estate.url_soc }}" class="soc-button">
                        <img
                          src="https://socasesores.com/simulador-credito-hipotecario/img/icono_blanco.png"
                          width="20%"
                          height="auto"
                        />
                        &nbsp;Simula tu hipoteca
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex; justify-content: center">
                <ng-container *ngIf="galleryImages">
                  <ngx-gallery
                    #gallery
                    [options]="galleryOptionsT3"
                    [images]="galleryImages"
                    class="ngx-gallery"
                    style="border-radius: 20px !important"
                  >
                  </ngx-gallery>
                </ng-container>
              </div>
              <div class="row" *ngIf="property.videoUrl && property.videoUrl != 0 && property.videoUrl != null">
                <div class="col-12">
                  <div class="text-center">
                    <h3 class="mt-1">Video</h3>
                    <iframe
                      width="100%"
                      style="max-width: 560px"
                      height="315"
                      [src]="videoUrlSafe"
                      [title]="property.title"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>

              <br />
              <div class="row">
                <div class="col-12 cardBloque mb-1 p-2">
                  <h2 class="text-center">Lo que ofrece este lugar</h2>
                  <div class="row">
                    <div class="col-xs-12 col-md-6">
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.front != 0">
                        <img src="assets/icon/IconBlue/area.png" height="25" width="25" />
                        &nbsp;
                        <span>{{ property.front | number : "1.0-0" }} m </span>
                        <div class="amenity">Frente</div>
                      </div>
                      <div class="m-1" *ngIf="property?.propertyType_id === 4 && property?.depth != 0">
                        <img src="assets/icon/IconBlue/area.png" height="25" width="25" />
                        &nbsp;
                        <span>{{ property.depth | number : "1.0-0" }} m </span>
                        <div class="amenity">Fondo</div>
                      </div>
                      <div *ngFor="let amenityB of amenities_base" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityB.icon" height="25" width="25" />
                        &nbsp;
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') == 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span
                          *ngIf="
                            amenityB.id == 2 &&
                            amenityB.cantidad - (amenityB.cantidad | number : '1.0-0') != 0 &&
                            amenityB.cantidad < 4
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-1" }}
                        </span>
                        <span *ngIf="amenityB.id == 2 && amenityB.cantidad >= 4"> Más de 3 </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad != '4.00'
                          "
                        >
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <span *ngIf="amenityB.id == 3 && amenityB.cantidad == 0"> Sin </span>
                        <span
                          *ngIf="
                            (amenityB.id == 1 || (amenityB.id == 3 && amenityB.cantidad > 0) || amenityB.id == 6) &&
                            amenityB.cantidad == '4.00'
                          "
                        >
                          Más de 3
                        </span>
                        <span *ngIf="amenityB.id == 4 || amenityB.id == 5">
                          {{ amenityB.cantidad | number : "1.0-0" }}
                        </span>
                        <div [innerHTML]="amenityB.name" class="amenity"></div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                      <div *ngFor="let amenityOp of amenities_ops" class="m-1">
                        <img [src]="'assets/icon/IconBlue/' + amenityOp.icon" height="25" width="25" />
                        &nbsp;
                        <div [innerHTML]="amenityOp.name" class="amenity"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 cardBloque mb-1 p-2">
                  <h2 class="text-center">Descripción</h2>
                  <div>
                    <label style="white-space: pre-line">{{ property.description }}</label>
                  </div>
                  <br />
                  <div>
                    <div *ngFor="let pb of property.property_buttons">
                      <button
                        type="button"
                        class="btn btn-relief-primary round mb-1"
                        style="width: 300px"
                        (click)="linkTo(pb.url)"
                      >
                        {{ pb.description }}
                      </button>
                    </div>
                    <a target="_blank" href="{{ property?.url_soc }}" class="soc-button" *ngIf="property?.url_soc">
                      <img
                        src="https://socasesores.com/simulador-credito-hipotecario/img/icono_blanco.png"
                        width="20%"
                        height="auto"
                      />
                      &nbsp;Simula tu hipoteca
                    </a>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <div class="contactBtn p-1" style="z-index: 10">
                    <div class="d-flex justify-content-center">
                      <div class="container-whats mt-1" (click)="sendWhatsApp()">
                        <div class="contour">
                          <img
                            *ngIf="config?.logo"
                            [src]="config?.logo"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            style="border-radius: 100%"
                          />
                          <img
                            *ngIf="!config?.logo"
                            src="r../../../../../assets/images/phone2.png"
                            alt="Imagen superpuesta"
                            width="100%"
                            height="100%"
                            class="fas"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="property.operationType !== 'Renta'">
                <div class="col-12 cardBloque mb-1 p-2">
                  <h2 class="text-center">Calculadora de hipoteca</h2>
                  <h1
                    class="price py-2"
                    [style]="'color:' + config?.primaryColor + ' !important;'"
                    style="font-size: 3.5rem; text-align: center"
                  >
                    {{ property.price | customCurrency }} {{ getCoinTypeName(property.coin_type) }}
                    <a (click)="redirect(modalBasic)">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        fill="currentColor"
                        class="calculator"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
                        />
                        <path
                          d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"
                        />
                      </svg>
                    </a>
                  </h1>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </ng-container>

      <div class="container-lg container-md container-xl" *ngIf="property.exactLocation">
        <div class="row mt-1 px-1">
          <div class="col">
            <div class="row">
              <div class="col-12 d-flex justify-content-start mb-1">
                <button
                  *ngIf="property.exactLocation == true"
                  type="button"
                  class="btn btn-primary round location"
                  (click)="redirectMap()"
                  rippleEffect
                  [style]="
                    'border-color:' +
                    config?.primaryColor +
                    ' !important;background-color:' +
                    config?.primaryColor +
                    ' !important;color:' +
                    config.secondaryColor +
                    ' !important;'
                  "
                >
                  <i data-feather="map-pin" class="m-auto"></i>
                  Ver localización
                </button>
              </div>
              <!-- <div class="col-12" id="mapClass" *ngIf="property.exactLocation == true">
                <div id="map" class="sticky-top" style="position: fixed; height: 325px; z-index: 2"></div>
              </div> -->
              <div class="col-12 mt-1 mb-2" id="shareClass">
                <h4 class="text-center">Compartir propiedad</h4>
                <div style="display: flex; justify-content: center; align-items: center">
                  <a
                    [href]="
                      'https://www.facebook.com/sharer/sharer.php?u=' +
                      'https://back.in-mo.app/' +
                      this.property['real_estate']['domain'] +
                      '/' +
                      property.id
                    "
                    target="_blank"
                  >
                    <button
                      type="button"
                      class="btn btn-icon btn-icon rounded-circle"
                      [style]="
                        'border-color:' +
                        config?.primaryColor +
                        ' !important;background-color:' +
                        config?.primaryColor +
                        ' !important;color:' +
                        config.secondaryColor +
                        ' !important;'
                      "
                      rippleEffect
                    >
                      <span [data-feather]="'facebook'" size="20"></span>
                    </button>
                  </a>
                  <button
                    type="button"
                    class="btn btn-icon btn-icon rounded-circle ml-2"
                    [style]="
                      'border-color:' +
                      config?.primaryColor +
                      ' !important;background-color:' +
                      config?.primaryColor +
                      ' !important;color:' +
                      config.secondaryColor +
                      ' !important;'
                    "
                    rippleEffect
                    (click)="modalOpenLink(modallink, 1)"
                  >
                    <span [data-feather]="'link'" size="20"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="galleryImages.length > 0 && (config?.theme === 2 || config?.theme === 1)">
        <ngx-gallery #gallery [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery"> </ngx-gallery>
      </ng-container>
    </ng-template>
  </ng-template>

  <app-footer class="mt-auto" *ngIf="onlyDetails"> </app-footer>
</div>

<!-- Modal -->
<ng-template #modallink let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Copiar enlace</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-1"></div>
      <div class="col-7">
        <div class="form-group">
          <label for="basicInput">Enlace</label>
          <input class="form-control" [(ngModel)]="urlShareCopy" />
        </div>
      </div>
      <div class="col-3">
        <button
          type="button"
          [cdkCopyToClipboard]="urlShareCopy"
          ngbTooltip="Copiado en portapapeles"
          triggers="click:blur"
          class="btn"
          [style]="
            'border-color:' +
            config?.primaryColor +
            ' !important;background-color:' +
            config?.primaryColor +
            ' !important;color:' +
            config.secondaryColor +
            ' !important;'
          "
          style="margin-top: 22px"
          rippleEffect
        >
          Copiar
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>
            Accept
        </button>
    </div> -->
</ng-template>

<!-- Modal -->
<ng-template #modalBasic let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Valoración hipoteca</h4>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <div class="row">
      <div class="col-xl-4 col-md-4 col-12 mb-1">
        <div class="form-group">
          <label for="basicInput">Precio</label>
          <div class="input-group input-group-merge round">
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input [(ngModel)]="valuation.priceText" type="text" class="result form-control round" disabled />
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-4 col-12 mb-1">
        <div class="form-group">
          <label for="basicInput">Enganche (Mínimo 10%)</label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="downPayment.invalid && (downPayment.dirty || downPayment.touched) ? 'is-invalid' : ''"
          >
            <div class="input-group-prepend">
              <span class="input-group-text round"><span [data-feather]="'dollar-sign'"></span></span>
            </div>
            <input
              placeholder="Ej.-$500,000.00"
              (ngModelChange)="onQtrInputChange($event)"
              (focus)="onFocusCommaInput()"
              (blur)="onBlurCommaInput()"
              [ngModel]="valuation.downPaymentText | currencyCommasHundredsLanding"
              type="text"
              class="form-control round"
              [maxLength]="13"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
              required
              [ngClass]="downPayment.invalid && (downPayment.dirty || downPayment.touched) ? 'is-invalid' : ''"
              name="downPayment"
              id="downPayment"
              #downPayment="ngModel"
            />
          </div>
          <div *ngIf="downPayment.invalid && (downPayment.dirty || downPayment.touched)" class="alert">
            <small class="text-danger" *ngIf="downPayment.errors?.['required']"> El enganche es obligatorio </small>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-4 col-12 mb-1">
        <div class="form-group">
          <label for="basicInput">Plazo</label>
          <div
            class="input-group input-group-merge round"
            [ngClass]="time.invalid && (time.dirty || time.touched) ? 'is-invalid' : ''"
          >
            <ng-select
              class="custom"
              [items]="plazos"
              bindLabel="name"
              bindValue="value"
              [loading]="plazosLoading"
              [(ngModel)]="valuation.time"
              name="time"
              id="time"
              #time="ngModel"
              required
              [ngClass]="time.invalid && (time.dirty || time.touched) ? 'is-invalid' : ''"
            >
            </ng-select>

            <!-- <select class="form-control round" id="basicSelect" required
                            [ngClass]="time.invalid && (time.dirty || time.touched) ? 'is-invalid' : ''" name="time"
                            id="time" #time="ngModel" [(ngModel)]="valuation.time">
                            <option [value]="15">15</option>
                            <option [value]="20">20</option>
                        </select> -->
          </div>
          <div *ngIf="time.invalid && (time.dirty || time.touched)" class="alert">
            <small class="text-danger" *ngIf="time.errors?.['required']"> El plazo es obligatorio </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isVisible">
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <div class="form-group">
            <label>Préstamo</label>
            <div class="input-group input-group-merge round">
              <input [ngModel]="prestamo | currency" type="text" class="result form-control round" disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <div class="form-group">
            <label>Mensualidad</label>
            <div class="input-group input-group-merge round">
              <input [ngModel]="mensualidad | currency" type="text" class="result form-control round" disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <div class="form-group">
            <label>Comisión apertura</label>
            <div class="input-group input-group-merge round">
              <input [ngModel]="comisionApertura | currency" type="text" class="result form-control round" disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <div class="form-group">
            <label>Impuestos</label>
            <div class="input-group input-group-merge round">
              <input [ngModel]="impuestos | currency" type="text" class="result form-control round" disabled />
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-md-4 col-12">
        <div class="form-group">
          <div class="form-group">
            <label>Total enganche</label>
            <div class="input-group input-group-merge round">
              <input [ngModel]="totalEnganche | currency" type="text" class="result form-control round" disabled />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn round"
      (click)="clean()"
      rippleEffect
      [style]="
        'border-color:' +
        config.secondaryColor +
        ' !important;background-color:' +
        config.secondaryColor +
        ' !important;color:' +
        config?.primaryColor +
        ' !important;'
      "
    >
      <i data-feather="x-circle" class="mr-0 mr-sm-1"></i>
      Limpiar valoración
    </button>
    <button
      type="button"
      class="btn round"
      [style]="
        'border-color:' +
        config?.primaryColor +
        ' !important;background-color:' +
        config?.primaryColor +
        ' !important;color:' +
        config.secondaryColor +
        ' !important;'
      "
      (click)="makeV()"
      rippleEffect
    >
      <i data-feather="check" class="mr-0 mr-sm-1"></i>
      Realizar valoración
    </button>
  </div>
</ng-template>

<!-- Modal -->
<ng-template #modalBasic2 let-modal>
  <div class="modal-header">
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0" ngbAutofocus>
    <ngb-carousel>
      <ng-template ngbSlide *ngFor="let imgs of carrusel">
        <div class="carousel-img-wrapper">
          <img [src]="url + imgs" class="imagenCarrusel img-fluid rounded" alt="Random first slide" />
        </div>
        <div class="carousel-caption"></div>
      </ng-template>
    </ngb-carousel>
  </div>
</ng-template>
